import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=1fb5a114&scoped=true&name=arrow-link&"
import script from "./ArrowLink.vue?vue&type=script&lang=js&"
export * from "./ArrowLink.vue?vue&type=script&lang=js&"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=1fb5a114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5a114",
  null
  
)

export default component.exports